import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || 'http://localhost:3000/api/v1',
  timeout: 15000,
});

export function getSiteSettings() {
  return api.get('/site-settings').then((res) => res.data);
}

export function getCategories() {
  return api.get('/category').then((res) => res.data);
}

export function getProducts(params) {
  return api.get('/product', { params }).then((res) => res.data);
}

export function getFeaturedProducts() {
  return api.get('/product/featured').then((res) => res.data);
}

export function getProduct(slug) {
  return api.get(`/product/${slug}`).then((res) => res.data);
}

export function getServices() {
  return api.get('/service').then((res) => res.data);
}

export function getFeatures() {
  return api.get('/feature').then((res) => res.data);
}

export function getFaqs() {
  return api.get('/faq').then((res) => res.data);
}

export function getTestimonials() {
  return api.get('/testimonial').then((res) => res.data);
}

export function getTrustItems() {
  return api.get('/trust-item').then((res) => res.data);
}

export function getProcessSteps() {
  return api.get('/process-step').then((res) => res.data);
}

export function submitWholesaleApplication(body) {
  return api.post('/wholesale-application', body).then((res) => res.data);
}

export function submitQuoteRequest(body) {
  return api.post('/quote-request', body).then((res) => res.data);
}

export function submitContactMessage(body) {
  return api.post('/contact-message', body).then((res) => res.data);
}

export function getContentPage(slug) {
  return api.get('/content-page/slug/' + slug).then((r) => r.data);
}

export function getContentPages() {
  return api.get('/content-page').then((r) => r.data);
}

export default api;
